import { NotificationEngineSourceDTO } from '@/services/Hub/notificationCenter/types';
import { FieldDefinition } from '../../AdvancedExpressionBuilder';
import { FIELD_TYPE_MAPPING } from './constants';

export const engineSourceFieldsToFieldDefinition = (
  fields: NotificationEngineSourceDTO[]
): FieldDefinition[] => {
  return fields.map(field => {
    const { fieldIdentifier, description, fieldType, components } = field;

    const identifier = fieldIdentifier.replace(/_/g, '.');

    return {
      identifier: identifier,
      label: description,
      fieldType: FIELD_TYPE_MAPPING[fieldType] || 'select',
      components: components
    };
  });
};
